import { FC, ReactNode } from "react";

import { Add } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";

// Shared layout for resource "management" list pages: a title with an optional
// primary action button on the right, above a full-height content area (the
// table/list). Mirrors the Form/Survey Management pages in RubiREPORT so that
// feedback, reports, and future apps present management lists with identical
// spacing and affordances.
// EXTRACT: candidate for libs/ui — see feedback/COMPONENT_PROPOSAL.md (§3.8).

export interface ManagementListLayoutProps {
  title: string;
  // Primary action shown top-right (e.g. "Create Survey"). Omit both to render
  // a header with no action button.
  actionLabel?: string;
  onAction?: () => void;
  // Defaults to a "+" (Add) icon when an action is provided.
  actionIcon?: ReactNode;
  children: ReactNode;
}

const ManagementListLayout: FC<ManagementListLayoutProps> = ({
  title,
  actionLabel,
  onAction,
  actionIcon,
  children,
}) => (
  <Box sx={{ p: 3, height: "100%", display: "flex", flexDirection: "column" }}>
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 2,
        mb: 2,
      }}
    >
      <Typography variant="h5">{title}</Typography>
      {actionLabel && onAction && (
        <Button
          variant="contained"
          color="primary"
          startIcon={actionIcon ?? <Add />}
          onClick={onAction}
        >
          {actionLabel}
        </Button>
      )}
    </Box>
    <Box sx={{ flex: 1, minHeight: 0 }}>{children}</Box>
  </Box>
);

export default ManagementListLayout;
